// extracted by mini-css-extract-plugin
export default {"MonthlyExamPreparationFinished":"monthlyExamPreparationFinished_MonthlyExamPreparationFinished__5wN1h"};